<section class="m-content-section" [class]="type">
  <header>
    <ng-content select="[slotTitle]"></ng-content>
  </header>
  <div class="content">
    <ng-content select="[slotContent]"></ng-content>
  </div>
</section>
